module.exports = __webpack_public_path__ + "img/9788994475639.6ac3817c.jpg";